export const SUBTOPICS_REQUEST = "SUBTOPICS_REQUEST";
export const SUBTOPICS_SUCCESS = "SUBTOPICS_SUCCESS";
export const SUBTOPICS_FAILURE = "SUBTOPICS_FAILURE";